export const convertAmnVolumeToUcsVolume = (amnVolume: number): number => {
  // AMN volume is a float between 0 and 1, while UCS volume is an integer between 0 and 100
  return Math.round(amnVolume * 100)
}

export const convertUcsVolumeToAmnVolume = (ucsVolume: number): number => {
  // UCS volume is an integer between 0 and 100, while AMN volume is a float between 0 and 1
  return ucsVolume / 100
}
